import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const LicenseCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.LICENSES, "uid");